import { FC } from 'react'
import { Lock, Unlock } from 'lucide-react'
import { Markdown } from 'components/markdown'
import { cn } from '@wellesley/ui'

type TitleBlockProps = {
  title: string
  serverVersion: string
  isPrivate: boolean
  description?: string
  isDarkBg?: boolean
}

export const TitleBlock: FC<TitleBlockProps> = ({
  title,
  serverVersion,
  isPrivate,
  description,
  isDarkBg,
}) => {
  const textColorClass = isDarkBg ? 'text-white' : 'text-gray-900'
  const metadataColorClass = isDarkBg ? 'text-white/70' : 'text-gray-900/50'
  const markdownClassName = isDarkBg
    ? 'mt-m text-white [&_span]:text-white/70 [&_h1]:text-white [&_h2]:text-white [&_p]:text-white [&_li]:text-white [&_code]:text-white [&_pre]:text-white [&_blockquote]:text-white'
    : 'mt-m'

  return (
    <div
      data-testid="branding-title-block"
      className="flex w-full flex-col items-center pt-m"
    >
      <h1
        className={cn(
          'text-center text-[40px] font-bold leading-[40px]',
          textColorClass,
        )}
      >
        {title}
      </h1>
      <div
        className={cn(
          'my-xs flex items-center gap-xxxs text-base font-medium',
          metadataColorClass,
        )}
      >
        {isPrivate ? (
          <>
            <Lock size={16} />
            <span>Private server</span>
          </>
        ) : (
          <>
            <Unlock size={16} />
            <span>Public server</span>
          </>
        )}
        <span>·</span>
        <span>v.{serverVersion}</span>
      </div>
      {description && (
        <div data-testid="branding-description">
          <Markdown markdown={description} className={markdownClassName} />
        </div>
      )}
    </div>
  )
}
